module.exports = __webpack_public_path__ + "media/common/loading-fb25a3f0.svg";